import VPagination from 'vuetify/lib/components/VPagination/VPagination';

export default VPagination.extend({
    name: 'PrimeCarouselPagination',
    props: {
        carouselItems: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            visibleValues: [],
        };
    },
    computed: {
        items() {
            if (this.visibleValues.length === 0 || this.value === 0) {
                this.initItems();
            } else if (this.value === this.carouselItems.length - 1) {
                this.initItems(true);
            } else if (
                this.visibleValues.includes(this.value) &&
                this.visibleValues.indexOf(this.value) === this.primeCarouselLength
            ) {
                setTimeout(() => {
                    this.updateItems();
                }, 200);
            } else if (this.visibleValues.includes(this.value) && this.visibleValues.indexOf(this.value) === 0) {
                setTimeout(() => {
                    this.updateItems(false);
                }, 200);
            } else if (this.visibleValues.includes(this.value) === false) {
                if (this.visibleValues[0] > this.value) {
                    this.createItemsLeft();
                } else if (this.visibleValues[this.primeCarouselLength] < this.value) {
                    this.createItemsRight();
                }
            }
            return this.visibleValues;
        },
        primeCarouselLength() {
            return this.length - 1;
        },
    },
    methods: {
        initItems(tail = false) {
            this.visibleValues.splice(0);
            this.carouselItems.some(i => {
                if (tail === true) {
                    if (i > this.getTailIndex()) {
                        this.visibleValues.push(i);
                    }
                } else {
                    this.visibleValues.push(i);
                }
                if (this.visibleValues.length === this.length) {
                    return true;
                }
            });
        },
        updateItems(increment = true) {
            this.visibleValues = this.visibleValues.map(val => {
                if (increment) {
                    return ++val;
                } else {
                    return --val;
                }
            });
        },
        createItemsLeft() {
            this.visibleValues.splice(0);
            for (let i = this.value - 1; this.visibleValues.length < this.length; i++) {
                this.visibleValues.push(i);
            }
        },
        createItemsRight() {
            this.visibleValues.splice(0);
            for (let i = this.value - this.length + 1; this.visibleValues.length < this.length; i++) {
                this.visibleValues.push(i);
            }
        },
        genItems(h) {
            return this.items.map((i, index) => {
                return h('li', { key: index }, [this.genItem(h, i, this.getSize(i))]);
            });
        },
        genItem(h, i, size) {
            return h(
                'v-btn',
                {
                    class: {
                        'v-carousel__controls__item': true,
                    },
                    props: {
                        icon: true,
                        small: true,
                        value: i,
                    },
                    style: {
                        width: '18px !important',
                        padding: '0 !important',
                        margin: '0 !important'
                    },
                    on: {
                        click: () => {
                            return this.$emit('input', i);
                        },
                    },
                },
                [
                    this.$createElement(
                        'v-icon',
                        {
                            props: {
                                size,
                                color: i === this.value ? 'primary' : '#000000',
                            },
                        },
                        '$vuetify.icons.delimiter',
                    ),
                ],
            );
        },
        getSize(i) {
            let size = 18;
            if (
                [0, this.primeCarouselLength].includes(this.visibleValues.indexOf(i)) &&
                i !== 0 &&
                i !== this.carouselItems.length - 1
            ) {
                size = 9;
            }
            return size;
        },
        getTailIndex() {
            return this.carouselItems.length - this.length - 1;
        },
    },
    render(h) {
        var children = [this.genItems(h)];
        return h(
            'ul',
            {
                directives: [
                    {
                        modifiers: { quiet: true },
                        name: 'resize',
                        value: this.onResize,
                    },
                ],
                class: this.classes,
            },
            children,
        );
    },
});
